import React from "react";

export default function SectorContact(props) {
  return (
    <React.Fragment>
      <div>
        {(props.sector.toUpperCase().includes('GOV') || props.sector.toUpperCase().includes('SCIENCE') || props.sector.toUpperCase().includes('PROFIT')) ?
          <table width="100%">
            <thead>
              <tr>
                <th >Sector</th>
                <th >Name</th>
                <th >Contact Number</th>
                <th >E-mail</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Government</td>
                <td>Dr Mario Clayford</td>
                <td>021 466 7829</td>
                <td>Mario.Clayford@dsti.gov.za</td>
              </tr>
              <tr>
                <td>Government</td>
                <td>Mr Theodore Sass (Sector Leader)</td>
                <td>021 466 7872</td>
                <td>Theodore.Sass@dsti.gov.za</td>
              </tr>
              <tr>
                <td>Not-For-Profit</td>
                <td>Ms Natasha Saunders (Sector Leader)</td>
                <td>021 466 7886</td>
                <td>Natasha.Saunders@dsti.gov.za</td>
              </tr>
              <tr>
                <td>Science Councils</td>
                <td>Dr Mario Clayford (Sector Leader)</td>
                <td>021 466 7829</td>
                <td>Mario.Clayford@dsti.gov.za</td>
              </tr>
            </tbody>
          </table>


          : <span></span>}

        {props.sector.toUpperCase().includes('BUSINESS') ?
          <table width="100%">
            <thead>
              <tr>

                <th >Name</th>
                <th >Contact Number</th>
                <th >E-mail</th>
              </tr>
            </thead>
            <tbody>
              <tr>

                <td>Mr Jerry Mathekga (Sector Leader)</td>
                <td>021 466 7811</td>
                <td>Jerry.Mathekga@dsti.gov.za</td>
              </tr>
              <tr>

                <td>Dr Kgabo Ramoroka </td>
                <td>021 466 8004</td>
                <td>Kgabo.Ramoroka@dsti.gov.za</td>
              </tr>
              <tr>

                <td>Mr Theodore Sass</td>
                <td>021 466 7872</td>
                <td>Theodore.Sass@dsti.gov.za</td>
              </tr>

              <tr>

                <td>Mr Rory Liedeman</td>
                <td>021 466 7860</td>
                <td>Rory.Liedeman@dsti.gov.za</td>
              </tr>
              <tr>

                <td>Ms Zikhona Ngqula</td>
                <td>021 466 7834</td>
                <td>Zikhona.Ngqula@dsti.gov.za</td>
              </tr>

              


            </tbody>
          </table>

          : <span></span>}

        {props.sector.toUpperCase().includes('EDUCATION') ?

          <table width="100%">
            <thead>
              <tr>

                <th >Name</th>
                <th >Contact Number</th>
                <th >E-mail</th>
              </tr>
            </thead>
            <tbody>

              <tr>

                <td>Ms Natalie Vlotman</td>
                <td>021 466 7826</td>
                <td>Natalie.Lamberts@dsti.gov.za</td>
              </tr>
              <tr>

                <td>Ms Zikhona Ngqula</td>
                <td>021 466 7834</td>
                <td>Zikhona.Ngqula@dsti.gov.za</td>
              </tr>


            </tbody>
          </table>

          : <span></span>}
      </div>
    </React.Fragment>
  )

}

